import React from 'react';
import {observer, inject} from 'mobx-react';
import store from '../Header/store';
import './mobile.less';

@inject((stores, props) => ({
  ...props,
  uiStore: store
}))
@observer
class MobileNavBack extends React.Component {
  static defaultProps = {
    prefixClass: 'component-mobile-navback'
  };

  render() {
    const {prefixClass, title, onClose, onBack} = this.props;
    let isCloseFunc = false;
    let isBackFunc = false;
    if (typeof onClose === 'function') {
      isCloseFunc = true;
    }
    if (typeof onBack === 'function') {
      isBackFunc = true;
    }
    return (
      <div className={prefixClass}>
        <div className='header-left' onClick={onClose}>
          {isBackFunc && <i className='dpl20_left' onClick={onBack} />}
          {isCloseFunc && <i className='dpl20_wrong' onClick={onClose} />}
        </div>
        <div className='header-title'>{title}</div>
        <div className='header-right' />
      </div>
    );
  }
}

export default MobileNavBack;
